import React from 'react';
import './mainhero.css';

function MainHero() {
    return (
        <section id="ktemplehero">
            <div className="cs-container">
                <div className="cs-content">
                    <h1 className="cs-title">Begin your Spiritual Transformation</h1>
                    <a href="/about-krishna-temple" className="cs-button-solid">Hare Krishna</a>
                </div>
                <ul className="cs-card-group">
                    <li className="cs-item">
                        <img className="cs-icon" loading="lazy" decoding="async" src="/images/check-circle.svg" alt="icon" width="48" height="48"></img>
                        <h3 className="cs-h3">New to Temple</h3>
                        <p className="cs-item-text">
                            Krishna temple is profound of Spiritual power. Every prayer finds its answer, every wish is fulfilled, and every heartfelt desire is granted. Be a part of it, Hari Bol !!!
                        </p>
                        <a href="/about-krishna-temple" className="cs-button-solid">Get Started</a>
                    </li>
                    <li className="cs-item">
                        <img className="cs-icon" loading="lazy" decoding="async" src="/images/speedometer.svg" alt="icon" width="48" height="48"></img>
                        <h3 className="cs-h3">Events</h3>
                        <p className="cs-item-text">
                            The Krishna Temple hosts events throughout the year, with Kirtan and the chanting of the <strong>Hare Krishna Maha Mantra</strong> taking place every Sunday.  Welcome to join us for a spiritual experience.                      
                        </p>
                        <a href="/krishna-temple-events" className="cs-button-solid">Events at Temple</a>
                    </li>
                    <li className="cs-item">
                        <img className="cs-icon" loading="lazy" decoding="async" src="/images/hard-hat.svg" alt="icon" width="48" height="48"></img>
                        <h3 className="cs-h3">Radha Madhav Kitchen</h3>
                        <p className="cs-item-text">
                            <strong>Radha Madhav kitchen</strong> is open to everyone, serving delicious vegetarian meals. Planning a party or a spiritual program? Order your food and enjoy!
                        </p>
                        <a href="/radha-madhav-kitchen" className="cs-button-solid">Order Food</a>
                    </li>
                    <li className="cs-item">
                        <img className="cs-icon" loading="lazy" decoding="async" src="/images/Like.svg" alt="icon" width="48" height="48"></img>
                        <h3 className="cs-h3">Donate</h3>
                        <p className="cs-item-text">
                            To continue serving the community, we kindly request your generous donations. Any size of donation or Volunteer time is welcome and will be highly appreciated.
                        </p>
                        <a href="/donate" className="cs-button-solid">Donate to Temple</a>
                    </li>
                </ul>
            </div>
            <picture className="cs-background">
                <source media="(max-width: 600px)" srcSet="/images/krishna-hero.jpg"></source>
                <source media="(min-width: 601px)" srcSet="/images/krishna-hero.jpg"></source>
                <img decoding="async" src="/images/krishna-hero.jpg" alt="Krishna Temple Home" width="100%" height="auto" aria-hidden="true" className="responsive-image"></img>
            </picture>
        </section>
    );
}
export default MainHero;